<template>
  <div class="ai-pl">
    <div class="banner">
      <div class="inner">
        <h2>智慧供热行业解决方案</h2>
        <p>介绍</p>
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button style="margin-left: 3em;" @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>
    <div class="ai-main" v-for="o in 3" :key="o">
      <div class="ai-title">
        <h1>行业面临的挑战</h1>
        <img src="" alt="">
        <div class="include-heat" v-for="item in 2" :key="item">
          <p>{{ item }}这是一段演示文字这是一段演示文字这是一段演示文字这是一段演示文字，这是一段演示文字这是一段演示文字源码出售，仅需两包烟这是一段演示文字这是一段演示文字</p>
        </div>
      </div>
    </div>
    <div class="ai-celcase">
      <div class="ai-title">
        <h1>客户案例</h1>
        <p>Creators are cashing in with joinBrands. You can too - as a sidehustle or a full-time income.</p>
      </div>
      <div class="case-con">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content ep-bg-purple">

            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content ep-bg-purple">

            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content ep-bg-purple">

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script setup name="Ai_platform">
import { onMounted } from 'vue';
onMounted(() => {
  window.scrollTo(0, 0);
})
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
</script>

<style scoped>
.ai-pl {
  width: 100%;
}
.banner{
  position: relative;
  width: 100%;
  height: 25em;
  background-color: #ddd;
  margin-bottom: 8em;
}
.banner .inner{
  position: absolute;
  top:15%;
  left:10%;
}
.inner-le,.inner-ri{
  position: absolute;
  width: 8em;
  height: 3em;
  border-radius: 1.5em;
  top:18em;
  border:transparent;
  cursor: pointer;
}
.inner-le{
  background-color: orange;
  left:3em;
  color: white;
}
.inner-ri{
  background-color: skyblue;
  color: white;
  left:11em;
}
.ai-main,.ai-celcase{
  width: 60%;
  margin: 4em auto;
}
.ai-title>h1{
  width: 100%;
  text-align: center;
}
.ai-title>img{
  width: 100%;
  height: 20em;
  margin: 2em auto;
  background-color: #ddd;
}
.ai-title .include-heat>p{
  width: 100%;
  margin: 2em auto;
  text-indent: 2em;
}
.ai-celcase .ai-title>p{
  width: 60%;
  font-size: 1.2em;
  margin: 2em auto;
  text-align: center;
  line-height: 2em;
}
.grid-content{
  width: 100%;
  height: 20em;
  background-color: #ddd;
} 
</style>